import React from "react";
import useAuthStore from "../../store/authStore";
import useMediaRecorderUploader from "../../hooks/useMediaRecorderUploader";

function AgentRecordingController() {
    const { 
        recorderState, 
        startRecording, 
        record_audio, 
        record_screen
    } = useMediaRecorderUploader();
    
    const isUserAuthenticated = useAuthStore((state) => state.isAuthenticated);
    const isRecordingEnabled = record_audio || record_screen;

    if (!isRecordingEnabled) return null;

    // 1. IDLE STATE
    if (isUserAuthenticated && recorderState === "Idle") {
        return (
            <div style={styles.overlay}>
                <p style={{ color: 'black', fontSize: '24px', marginBottom: '20px' }}>
                    Screen recording is required.
                </p>
                <button onClick={startRecording} style={styles.button}>
                    Start Recording
                </button>
            </div>
        );
    }
    
    // 2. PREPARING
    if (recorderState === "Preparing") {
        return (
             <div style={styles.overlay}>
                <p style={{ color: 'black', fontSize: '24px' }}>Waiting for permissions...</p>
             </div>
        );
    }

    // 3. DENIED
    if (recorderState === "PermissionDenied") {
        return (
            <div style={{ ...styles.overlay, color: 'red' }}>
                <p style={{ fontSize: '24px', textAlign: 'center' }}>
                    Permission Denied. <br/> Please reset browser permissions and try again.
                </p>
                <button onClick={startRecording} style={{...styles.button, marginTop: '20px'}}>
                    Retry
                </button>
            </div>
        );
    }

    return null;
}

const styles = {
    overlay: {
        position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
        backgroundColor: 'white',
        display: 'flex', flexDirection: 'column',
        justifyContent: 'center', alignItems: 'center',
        zIndex: 9999,
    },
    button: {
        padding: '10px 20px', fontSize: '18px', cursor: 'pointer',
        backgroundColor: '#333', color: 'white', border: 'none', borderRadius: '5px'
    }
};

export default AgentRecordingController;